export default __webpack_public_path__ + "static/media/profile-photo-ideas.f42ef71e.jpeg";